import { EMPTY } from '../pattern/empty';

/**
 * Filtre de l'outil Gomme : décide si une cellule doit être effacée selon la
 * couleur active en palette.
 *
 * Sémantique :
 *  - `filterIdx === EMPTY` (-1) → gomme « globale » : efface toute cellule
 *    posée, quelle que soit sa couleur.
 *  - `filterIdx >= 0` → gomme « ciblée » : n'efface que les cellules dont
 *    l'index courant matche le filtre. Les autres cellules dans la footprint
 *    du pinceau sont ignorées.
 *
 * Utilisé en pinceau (1×1, 3×3, 5×5) pour permettre de nettoyer une seule
 * teinte sans effacer ses voisines.
 */
export function passesEraseFilter(baseIdx: number, filterIdx: number): boolean {
  if (filterIdx === EMPTY) return true;
  return baseIdx === filterIdx;
}
